import { useMemo } from 'react';
import FiltersStore from '@features/categories/mobx/stores/FiltersStore';
import { IVirtualCategoryFilters } from '@features/categories';
let currentStore: FiltersStore | null;
const initializeStore = (data, arrangementProducts, sortingData, categoryId: number, initAddress?: string, virtualCategoryFilters: IVirtualCategoryFilters | null = null, virtualCategorySlug: string | null = null) => {
  // Reuse store on return from product (same category) — preserves pagination / loaded products
  if (typeof window !== 'undefined' && currentStore && currentStore.categoryId === categoryId && currentStore.virtualCategorySlug === virtualCategorySlug) {
    currentStore.reattachListeners();
    return currentStore;
  }

  // Category (or virtual category) changed — reset and create a new store
  if (currentStore && (currentStore.categoryId !== categoryId || currentStore.virtualCategorySlug !== virtualCategorySlug)) {
    currentStore.resetStore();
    currentStore = null;
  }
  const newStore = currentStore ?? new FiltersStore(data, arrangementProducts, sortingData, categoryId, initAddress, virtualCategoryFilters, virtualCategorySlug);
  if (typeof window === 'undefined') return newStore;
  if (!currentStore) currentStore = newStore;
  return newStore;
};
const useFiltersStore = (data, arrangementProducts, sortingData, categoryId: number, initAddress?: string, virtualCategoryFilters: IVirtualCategoryFilters | null = null, virtualCategorySlug: string | null = null) => {
  const store = useMemo(() => initializeStore(data, arrangementProducts, sortingData, categoryId, initAddress, virtualCategoryFilters, virtualCategorySlug), [categoryId, virtualCategorySlug]);
  return store;
};
export { FiltersStore, useFiltersStore };